
import React, { useEffect, useRef, useState } from "react";
import axios from 'axios';
import styled from "styled-components";
import './style.css';
import { toast } from "react-toastify";
import { FaSave } from "react-icons/fa";
import fundo from "../../../../styles/fundo.svg";


const FormContainer = styled.form`
  width: auto;
  max-width: 700px;
  background-color: #f4f4f5;
  display: flex; 
  align-items: flex-start;
  flex-direction: row;
  box-shadow: 0px 0px 2px #ccc;
  padding: 10px;
`;

const DivContainer = styled.form`
  width: auto;
  background-color: #f5f5f5;
  display: flex; 
  align-items: center;
  flex-direction: column;

  padding: 10px;
`;

const Div = styled.div`
  width: 100%;
  background-color:#f4f4f5;
  display: flex; 
  padding: 20px 10px 10px 10px;
  align-items: flex-end;
  gap: 20px 0px;
  flex-direction: row;

  textarea {
    width: 100%;
    min-height: 80px;
    resize: none;
    overflow: hidden;
    white-space: pre-wrap; 
    word-wrap: break-word;
    color: #575757;
    padding: 0px 0px 0px 10px;
    border: 1px solid #ccc;
    border-radius: 10px;
    background-color:#f4f4f5;
  }
  
 
`;



const TextAreaContainer = styled.div`
  width: 100%;
  height: auto; 
  display: flex;
  flex-direction: column;
`;


const InputTitle = styled.textarea`
  min-width: 600px; 
  min-height: 80px;
  font-size: 22px;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 10px 20px;
  color: #3a3f42;
  background-color: #f4f4f5;
  overflow: auto;
  box-sizing: border-box; /* Incluir o padding e a borda na largura total */
  white-space: pre-wrap; /* Manter quebras de linha e espaços */
  line-height: 1.5; /* Ajustar o espaçamento entre as linhas */
  word-wrap: break-word; /* Permitir quebra de palavras longas */
`;


const InputDescricao = styled.textarea`
  min-width: 600px; 
  min-height: 200px;
  font-size: 18px;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 10px 10px 00px 20px;
  color: #3a3f42;
  background-color: #f4f4f5;
  resize: none; /* Desabilitar o redimensionamento manual */
  box-sizing: border-box; /* Incluir o padding e a borda na largura total */
  overflow: auto; /* Permitir a rolagem automática */
  white-space: pre-wrap; /* Manter quebras de linha e espaços */
`;




const Label = styled.label`
  color: #3a3f42;
  font-weight: bold;
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  margin: 0px 5px;
  padding: 0px 0px 0px 10px; 


`;

const Button = styled.button`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 10px ;
  cursor: pointer;
  border: none;
  background-image: url(${fundo});
  color: #fff;
  font-size: bold;
  font-size: 20px;
  gap: 5px;
  margin-top: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;


`;

const ButtonNew = styled.button`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 10px ;
  cursor: pointer;
  border: none;
  background-color: transparent;
  color: #3a3f42;
  font-size: 20px;
  gap: 5px;
  margin-top: 10px;
  transition: transform 0.3s;
  border: 1px solid #ccc;
  border-radius: 10px;
    &:hover {

    box-shadow: 0 4px 6px gray;
  }

`;

export const Td = styled.td`
  font-size: 16px;
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  color: #3a3f42;
  width: 400px;

`;


export const Thead = styled.thead``;

export const Tbody = styled.tbody`
  padding-bottom: 05px; 
`;

export const Th = styled.th`
  color: #4f4f4f;
  text-align: start;
  border-bottom: inset;
  padding-bottom: 5px;
`;



const Form = ({ editarQuadro, modalVerQuadro, setVerQuadro, urlApi, fetchQuadro }) => {

  //Token da api
  const token = localStorage.getItem('token');


  //--------------------------------RECEBE OS DADOS DO STATE PARA PREENCHER PO FORM-------------------------------------------//
  //Recebe os valores para editar, tipo onEdit
  const ref = useRef();
  useEffect(() => {
    if (editarQuadro) {
      const user = ref.current;
      user.descricao_quadro.value = editarQuadro.DESCRICAO_QUADRO;
      user.titulo_quadro.value = editarQuadro.TITULO_QUADRO;
    }

  }, [editarQuadro]);



  //---------------------------------FECHA O MODAL E ABRE O GRID COM O QUADRO------------------------------------------//


  const handleVerQuadro = () => {
    setVerQuadro(editarQuadro); // Atualiza o estado após o fetch
    modalVerQuadro(); // Abre o modal
  };




  //-------------------------------ALTERAR O TITULO DO QUADRO--------------------------------------------//

  const [tituloQuadro, setTituloQuadro] = useState(editarQuadro.TITULO_QUADRO);
  const [isSaveButtonVisible, setIsSaveButtonVisible] = useState(false);
  const [originalTitulo, setOriginalTitulo] = useState(editarQuadro.TITULO_QUADRO); // Mantém o valor original

  const handleTituloChange = async (e) => {
    e.preventDefault();
    const newTitulo = e.target.value;
    setTituloQuadro(newTitulo);

    // Exibe o botão apenas se o título foi modificado
    setIsSaveButtonVisible(newTitulo !== originalTitulo);
  };

  const handleSave = async () => {
    if (tituloQuadro.trim() === "") {
      toast.warn("O título não pode estar vazio.");
      return;
    }

    if (tituloQuadro.length > 50) {
      toast.warn("O título não pode ter mais que 50 caracteres.");
      return;
    }

    try {
      await axios.put(
        `${urlApi}painel-monitoramento/alterar-quadro-titulo/${editarQuadro.ID_QUADRO}`,
        { titulo_quadro: tituloQuadro.trim() },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success("Título salvo com sucesso!");
      setOriginalTitulo(tituloQuadro.trim());
      setIsSaveButtonVisible(false);

      const quadroAtualizado = await fetchQuadro();
      setVerQuadro(quadroAtualizado);

    } catch (error) {
      console.error("Erro ao salvar título:", error);
      const msg = error?.response?.data?.error || "Erro ao salvar título.";
      toast.error(msg);
    }
  };

  //----------------------------------ALTERAR A DESCRIÇÂO DO QUADRO-----------------------------------------//

  const [descricaoQuadro, setDescricaoQuadro] = useState(editarQuadro.DESCRICAO_QUADRO);
  const [isSaveButtonVisibleDescricao, setIsSaveButtonVisibleDescricao] = useState(false);
  const [originalDescricao, setOriginalDescricao] = useState(editarQuadro.DESCRICAO_QUADRO); // Mantém o valor original

  const handleDescricaoChange = (e) => {
    const newDescricao = e.target.value;
    setDescricaoQuadro(newDescricao);
    setIsSaveButtonVisibleDescricao(newDescricao !== originalDescricao);
  };

  const handleSaveDescricao = async () => {
    if (descricaoQuadro.trim() === '') {
      toast.warn("A descrição não pode estar vazia.");
      return;
    }

    if (descricaoQuadro.length > 250) {
      toast.warn("A descrição não pode ter mais que 250 caracteres.");
      return;
    }

    try {
      setIsSaveButtonVisibleDescricao(false);

      await axios.put(
        `${urlApi}painel-monitoramento/alterar-quadro-descricao/${editarQuadro.ID_QUADRO}`,
        { descricao_quadro: descricaoQuadro.trim() },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const quadroAtualizado = await fetchQuadro();
      setVerQuadro(quadroAtualizado);
      setOriginalDescricao(descricaoQuadro.trim());
      toast.success("Descrição salva com sucesso!");
    } catch (error) {
      console.error("Erro ao salvar descrição:", error);
      const msg = error?.response?.data?.error || "Erro ao salvar descrição.";
      toast.error(msg);
    }
  };

  return (
    <div >
      <FormContainer>
        <DivContainer ref={ref} >

          <TextAreaContainer>
            <InputTitle
              id="titulo_quadro"
              type="text"
              value={tituloQuadro}
              onChange={handleTituloChange}
            />

            {(isSaveButtonVisible) && (
              <ButtonNew type="button" onClick={handleSave}> <FaSave color={"gold"} /> Salvar</ButtonNew>
            )}
          </TextAreaContainer>



          <Div>
            <TextAreaContainer>
              <Label>Descrição:</Label>
              <InputDescricao
                id="descricao_quadro"
                value={descricaoQuadro}
                onChange={handleDescricaoChange}
              />

              {(isSaveButtonVisibleDescricao) && (
                <ButtonNew type="button" onClick={handleSaveDescricao}><FaSave color={"gold"} /> Salvar </ButtonNew>
              )}
            </TextAreaContainer>
          </Div>

          <Button title="Ver o quadro" type="button" onClick={handleVerQuadro}>
            Ver quadro
          </Button>

        </DivContainer>


      </FormContainer>


      <style jsx global>{`
      .swal2-container.custom-swal-container {
        z-index: 9999; 
      }
    `}</style>
    </div >

  );
};

export default Form;


